import { createContext, useContext, useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";

const StatusContext = createContext({ statuses: [], byKey: {}, loading: true });

// Rendered before the catalogue arrives, and if the request fails. Deliberately
// NOT a second vocabulary: it is empty, so a failed fetch shows no options
// rather than a stale wrong list.
const EMPTY = { statuses: [], byKey: {}, loading: false };

export function StatusProvider({ children }) {
  const [state, setState] = useState({ ...EMPTY, loading: true });
  useEffect(() => {
    let alive = true;
    api.get("/desk/statuses")
      .then((r) => {
        if (!alive) return;
        const rows = asArray(r.data);
        setState({
          statuses: rows,
          byKey: Object.fromEntries(rows.map((s) => [s.key, s])),
          loading: false,
        });
      })
      .catch(() => alive && setState(EMPTY));
    return () => { alive = false; };
  }, []);
  return <StatusContext.Provider value={state}>{children}</StatusContext.Provider>;
}

export function useStatuses() {
  return useContext(StatusContext);
}
